import { createDirective as createCompatableDirective } from '@tencent/vue-compat/lib/directive';
import { bindMiddlewares } from "../middleware";
import { parseVueBindingValue } from "../util";
/**
 * 创建指令
 * @param {VueInstance} Vue Vue实例
 * @param {Promise<any>} reportPromise 异步Promise
 * @param {DirectiveOptions} options 指令配置
 * @param {String} options.name 指令名称，默认为v-report
 * @returns {Record<string, VueDirectiveHook>}
 */
export function createDirective(Vue, reportPromise = Promise.resolve(), options = { name: 'report' }) {
    function handleDirective(el, binding, event) {
        reportPromise.then(() => {
            bindMiddlewares(el, parseVueBindingValue(binding, event));
        });
    }
    const directives = createCompatableDirective({
        /**
         * @type {VftReport.DirectiveFunction}
         */
        bind(el, binding) {
            handleDirective(el, binding, 'bind');
        },
        /**
         * @type {VftReport.DirectiveFunction}
         */
        update(el, binding) {
            handleDirective(el, binding, 'update');
        },
        /**
         * @type {VftReport.DirectiveFunction}
         */
        unbind(el, binding) {
            handleDirective(el, binding, 'unbind');
        },
    }, Vue);
    const { name = 'report' } = options;
    Vue.directive(name, directives);
    return directives;
}
